import { serviceAgreementApi } from 'api';

export const getDocumentBinaryFromApi = async (serviceAgreementId: string, documentUid: string): Promise<Blob> => {
  const response = await serviceAgreementApi.getDocumentBinaryByIdRaw({
    serviceAgreementUid: serviceAgreementId,
    documentId: documentUid,
  });
  return response.raw.blob();
};
